<!-- <div class="container accountContainer">
    <h1 id="heading" style="font-size: 17px;"><strong>Delete Your Account</strong></h1>
    <p>We value your privacy and understand that you may wish to delete your account. If you no longer wish to use our services and want to delete your account, please follow the steps below:<br><br></p>
    <h6 id="heading"><strong>How to Delete Your Account</strong> </h6>
    <ol >
        <li id="heading"><strong>In-App Account Deletion:</strong></li>
        <ul>
            <li >Open the app on your device.
                Navigate to the Profile section.
                Select the Delete Account option.
                Follow the prompts to complete the deletion process.</li>
                <li >Request Account Deletion via Email:</li>
        </ul>
         <li id="heading"><strong>Request Account Deletion via Email:</strong>
        </li>
        <ul>
            <li>If you are unable to access the app, you can request account deletion by contacting us at <a href="mailto:foodjunctionstore2@gmail.com">foodjunctionstore2@gmail.com.</a>
            </li>
            <li>Please include your account details (e.g., mobile number, email address) to help us process your request efficiently.</li>
        </ul>
    </ol>
    <h6 id="heading"><strong>What Happens After Account Deletion</strong></h6>
    <ul>
        <li>All your personal data associated with your account will be permanently deleted.</li>
        <li>This action is irreversible. Once your account is deleted, we will not be able to recover your data.</li>
        
    </ul>
    <p>If you have any questions or need further assistance, please contact our support team at <a href="mailto:foodjunctionstore2@gmail.com">foodjunctionstore2@gmail.com.</a></p>
        <p>Thank you for using our service.</p>
</div> -->

<div style="max-width: 800px; margin: auto; padding: 2rem; font-family: Arial, sans-serif;">
    <h1 style="color: #c62828;font-size: 18px;" id="heading">Delete Your Account</h1>
  
    <p><strong>This page applies to both the <u>FoodJunction Store</u> mobile app and website, developed by <u>Rssquarz Tech Solutions Pvt Ltd</u>.</strong></p>
  
    <p>We respect your privacy and understand that you may wish to delete your account. If you no longer want to use our services and would like to delete your account, please follow one of the options below:</p>
  
    <h2 style="font-size: 17.5px;">How to Delete Your Account</h2>
  
    <h3 id="heading">Option 1: Delete Account from the App</h3>
    <ol>
      <li>Open the <strong>FoodJunction Store</strong> app on your mobile device.</li>
      <li>Navigate to the <strong>Profile</strong> section.</li>
      <li>Select the <strong>Delete Account</strong> option.</li>
      <li>Follow the prompts to confirm and complete the process.</li>
    </ol>
  
    <!-- <h3 id="heading">Option 2: Delete Account from the Website</h3>
    <ol>
      <li>Login to your account at <a href="https://foodjunctionstore.com" target="_blank">https://foodjunctionstore.com</a>.</li>
      <li>Go to your <strong>Profile</strong> or <strong>Account Settings</strong>.</li>
      <li>Click on the <strong>Delete Account</strong> option.</li>
      <li>Confirm your request to permanently delete your account.</li>
    </ol> -->
  
    <h3 id="heading">Option 2: Request Deletion via Email</h3>
    <p>If you are unable to access the app or website, you can request account deletion by emailing us at <a href="mailto:foodjunctionstore2@gmail.com">foodjunctionstore2@gmail.com</a>.</p>
    <p>Please include the following information to help us verify and process your request:</p>
    <ul>
      <li>Your registered mobile number</li>
      <li>Your email address (if used for registration)</li>
      <li>Any additional information to help us locate your account</li>
    </ul>
  
    <h2 id="heading">What Happens After Account Deletion</h2>
    <ul>
      <li>All your personal data and account information will be <strong>permanently deleted</strong>.</li>
      <li>This process is <strong>irreversible</strong>. Once deleted, your account and data cannot be recovered.</li>
      <li>Any active subscriptions or saved preferences will also be removed.</li>
    </ul>
  
    <h2 id="heading">Need Help?</h2>
    <p>If you have any questions or need assistance, feel free to contact our support team at <a href="mailto:foodjunctionstore2@gmail.com">foodjunctionstore2@gmail.com</a>.</p>
  
    <p>Thank you for using the <strong>FoodJunction Store</strong> app and website.</p>
  </div>
  